import { Fragment } from "react";
import { Stack, Alert, Collapse } from '@mui/material';

const SuccessError = (props) => {
    return (
        <Fragment>
            <Collapse in={props.successOpen}  >
                <Stack spacing={2}>
                    <Alert severity="success" onClose={() => props.closeSuccess()}>{props.successMessage}</Alert>
                </Stack>
            </Collapse>
            <Collapse in={props.errorOpen}  >
                <Stack spacing={2}>
                    {
                        (!props.closeError) &&
                        <Alert severity="error" >{props.errorMessage}</Alert>}
                    {
                     (props.closeError) &&
                        <Alert severity="error" onClose={() => props.closeError()}>{props.errorMessage}</Alert>
                    }
                </Stack>
            </Collapse>
        </Fragment>
    );
}
export default SuccessError;